import { useSidebarStore } from "@/stores/sidebarStore";

export const useSidebar = () => {
  const isExpanded = useSidebarStore((s) => s.isExpanded);
  const setIsExpanded = useSidebarStore((s) => s.setIsExpanded);
  return { isExpanded, setIsExpanded };
};
